<template>
  <v-card class="mx-auto" outlined height="450">
    <v-list-item>
      <v-list-item-content>
        <v-list-item-title class="headline mb-1">
          {{ $t('avatar') }}
        </v-list-item-title>
        <v-list-item-subtitle>
          {{ $t('manageAvatar') }}
        </v-list-item-subtitle>
      </v-list-item-content>
      <v-tooltip
        bottom
        :open-on-click="false"
        :open-on-focus="!isMobile"
        :open-on-hover="!isMobile"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            class="primary secondary--text"
            fab
            small
            v-bind="attrs"
            v-on="on"
            @click="clickEditUserInfo"
          >
            <v-icon v-if="isEditingUserInfo"> mdi-close </v-icon>
            <v-icon v-else> mdi-pencil </v-icon>
          </v-btn>
        </template>
        <span v-if="isEditingUserInfo">{{ $t('editCancel') }}</span>
        <span v-else>{{ $t('editAvatars') }}</span>
      </v-tooltip>
    </v-list-item>
    <v-form ref="avatarForm" v-model="validChangeUserInfo" lazy-validation>
      <v-list-item>
        <v-container>
          <v-row
            align="center"
            justify="center"
            no-gutters
            style="height: 258px"
          >
            <v-col cols="12" align="center" justify="center">
              <AppAvatar
                avatarColor="primary"
                initialsColor="secondary"
                :initialsSize="45"
                :userAvatar="fileURL"
                :userName="`${userModified.name} ${userModified.surname}`"
                avatarSize="150"
                iconSize="24"
              />
            </v-col>
            <v-col cols="10">
              <v-file-input
                accept="image/png, image/gif, image/jpeg"
                v-model="avatarFile"
                :label="$t('avatar')"
                :disabled="!isEditingUserInfo || loading"
              />
            </v-col>
            <v-col cols="2" align="end">
              <v-btn
                :disabled="
                  !isEditingUserInfo ||
                  loading ||
                  !userModified.avatarRef ||
                  !!avatarFile
                "
                class="primary secondary--text"
                fab
                small
                @click="removeAvatar"
              >
                <v-icon>mdi-delete-outline</v-icon>
              </v-btn>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-btn
                :disabled="!isEditingUserInfo || loading"
                :loading="loading"
                @click="updateUserAvatar()"
                block
                class="primary secondary--text"
              >
                {{ $t('updateData') }}
                <template v-slot:loader>
                  <v-progress-circular indeterminate size="20" width="2" />
                  <span class="ml-2">{{ $t('updatingUser') }}</span>
                </template>
              </v-btn>
            </v-col>
          </v-row>
        </v-container>
      </v-list-item>
    </v-form>
  </v-card>
</template>
<script>
import {
  getFileURL,
  removeFile,
  uploadAvatar,
} from '@/services/storage-service'
import { mapGetters, mapMutations } from 'vuex'
import { removeAvatar, updateUserInfo } from '@/services/user-service'

export default {
  async mounted() {
    this.user = { ...this.$store.state.user }
    this.userModified = { ...this.user }
    if (!this.user) return this.setNotFound(true)
  },
  computed: {
    ...mapGetters(['isMobile']),
    fileURL() {
      if (this.avatarFile) return URL.createObjectURL(this.avatarFile)
      else if (this.userModified.avatarURL) return this.userModified.avatarURL
      else return ''
    },
  },
  data() {
    return {
      avatarFile: undefined,
      user: {},
      userModified: {},
      isEditingUserInfo: false,
      loading: false,
      removeAvatarConfirmationDialog: false,
      validChangeUserInfo: false,
    }
  },
  methods: {
    ...mapMutations(['setNotFound', 'setSnackbar']),
    async updateUserAvatar() {
      if (!this.$refs.avatarForm.validate()) return
      this.loading = true
      try {
        let responseUpload
        if (this.avatarFile) {
          // Subimos la fotografía al storage
          responseUpload = await uploadAvatar(this.avatarFile)
          var avatarRef = responseUpload.metadata.fullPath
          var avatarURL = await getFileURL(avatarRef)

          // Actualizamos el usuario en firestore
          await updateUserInfo(this.$store.state.user.id, {
            avatarRef,
            avatarURL,
          })
          this.userModified.avatarRef = avatarRef
          this.userModified.avatarURL = avatarURL
        }

        // Resetamos y mostramos mensaje de éxito
        this.avatarFile = undefined
        const message = this.$t('updatingUserSuccess')
        this.setSnackbar({ position: 'top', type: 'success', message })
        this.isEditingUserInfo = false
      } catch (err) {
        const message = err
        this.setSnackbar({ position: 'top', type: 'error', message })
        this.loading = false
        return
      }
      this.loading = false
      this.user = { ...this.userModified }
    },
    async removeAvatar() {
      this.loading = true
      try {
        // Quitamos el archivo del storage
        await removeFile(this.userModified.avatarRef)

        // Borramos las referencias del archivo en el usuario
        await removeAvatar(this.$store.state.user.id)

        // Resetamos y mostramos mensaje de éxito
        this.userModified.avatarRef = ''
        this.userModified.avatarURL = ''
        this.avatarRef = undefined
        const message = this.$t('updatingUserSuccess')
        this.setSnackbar({ position: 'top', type: 'success', message })
        this.isEditingUserInfo = false
      } catch (err) {
        const message = this.$t('updatingUserError')
        this.setSnackbar({ position: 'top', type: 'error', message })
        this.loading = false
        return
      }
      this.loading = false
      this.user = { ...this.userModified }
    },
    clickEditUserInfo() {
      this.userModified = { ...this.user }
      this.avatarFile = undefined
      this.isEditingUserInfo = !this.isEditingUserInfo
    },
  },
}
</script>
